import React from "react";
// import { useNavigate } from "react-router-dom";
import Top from "../../Top";
import Left from "../../Left";
import { Button, Grid } from "@mui/material";
import SortIcon from "@mui/icons-material/Sort";
import SearchIcon from "@mui/icons-material/Search";
// import MicIcon from "@mui/icons-material/Mic";
// import TurnedInNotOutlinedIcon from "@mui/icons-material/TurnedInNotOutlined";

import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import CommentIcon from "@mui/icons-material/Comment";
import Zoom from "react-medium-image-zoom";
import SendIcon from "@mui/icons-material/Send";
import reecordNotFound from "../../../assets/Images/noData2.gif";

// import ThumbDownIcon from "@mui/icons-material/ThumbDown";

// For Modal
import Dialog from "@mui/material/Dialog";
// import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
// import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
// import NoticeTab from "./NoticeTab";
// import CreateNoticeModal from "./CreateNoticeModal";
// import DiscussionForumTab from "./DiscussionForumTab";
import NewConversationModal from "./NewConversationModal";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
// import TurnedInOutlinedIcon from "@mui/icons-material/TurnedInOutlined";
import PropTypes from "prop-types";

// End
import { makePostRequest, makeGetRequest } from "../../../utils/utils";
import swal from "sweetalert";
// import { AddComment, Update } from "@mui/icons-material";

// import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import moment from "moment";
// import Loader from "../../../assets/Images/loader.gif";
import avtarPic from "../../../assets/Images/avtarPic.png";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import Tooltip from "@mui/material/Tooltip";
import EditIcon from "@mui/icons-material/Edit";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import pdfImage from "../../../assets/Images/pdf.png";
import Pagination from '@mui/material/Pagination';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function DiscussionForumPage() {
  // const navigate = useNavigate();

  // For memu
  const [anchorEl, setAnchorEl] = React.useState(null);
  const openMenu = Boolean(anchorEl);

  const [value, setValue] = React.useState(0);
  // For Modal
  const [open, setOpen] = React.useState(false);
  const [scroll, setScroll] = React.useState("paper");
  const [Upload, setUpload] = React.useState(false);
  const [, setPostData] = React.useState([]);
  const [postList, setPostList] = React.useState([]);
  const [subPostList, setSubPostList] = React.useState([]);
  const [commentsList, setCommentsList] = React.useState([]);
  const [subCommentsList, setSubCommentsList] = React.useState([]);
  const [selectedItem, setSelectedItem] = React.useState({});
  const [activeIndex, setActiveIndex] = React.useState(null);
  // const [isLike, setIsLike] = React.useState(true);
  const [q, setQ] = React.useState();
  const [mostReplied] = React.useState(false);

  // const [Update, setUpdate] = React.useState(false);
  const [showLoader, setShowLoader] = React.useState(false);
  const [open2, setOpen2] = React.useState(false);
  const [selectedlikes, setselectedlikes] = React.useState(0);

  const [commentcnt, setcommentcnt] = React.useState(0);
  const [replycnt, setreplycnt] = React.useState(0);
  const [, setnoUpdate] = React.useState(true);
  const [postiddetail, setpostiddetail] = React.useState();
  const [loaddetails, setloaddetails] = React.useState(false);
  const [errmsg, seterrmsg] = React.useState(false);
  const [commerrmsg, setcommerrmsg] = React.useState(false);
  const [subcommerrmsg, setsubcommerrmsg] = React.useState(false);
  const [sort, setSort] = React.useState("newtoold");
  const [txtImage] = React.useState(
    require("../../../assets/Images/text.png")
  );
  const [excelImage] = React.useState(
    require("../../../assets/Images/exel.png")
  );
  const [wordImage] = React.useState(
    require("../../../assets/Images/doc.png")
  );

  //pagination
  const [currentPage, setCurrentPage] = React.useState(1);
  const [itemsPerPage] = React.useState(3);
  const [totalItems, setTotalItems] = React.useState(0);

  const MAX_LENGTH = 100;

  // const [tempList, setTempList] = React.useState([]);
  // const searchElement = (searchString) => {
  //   const lst = postList.find((element) => {
  //     return element.post_title === searchString;
  //   });
  //   // tempList.push(lstEle);
  //   // console.log("In A Search List ",lst.l)
  //   // if(lst.length>0)
  //   // {
  //   alert(lst);
  //   console.log("Lst ", lst);
  //   if (lst) {
  //     // let result = Object.keys(lst);
  //     // console.log("Converted List ", result);
  //   }
  //   // setPostList(lst);
  //   // }

  //   console.log("Searched List ", lst);
  // };

  const handlePageChange = (e, page) => {
    setCurrentPage(page);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  // const handleMostReplied = (event) => {
  //   // const strMostReplied = [...postList].sort((a, b) =>
  //   // a.postreplycount > b.postreplycount?1: (a.postreplycount > b.postreplycount)? -1 :0);

  //   let strMostReplied = postList.sort((a, b) => {
  //     return a.postreplycount > b.postreplycount;
  //   });

  //   console.log("Most Replied ", strMostReplied);
  //   setPostList(strMostReplied);
  //   setAnchorEl(null);
  // };

  const handleCloseMenu = (e) => {
    if (e.currentTarget.dataset.myValue !== undefined) {
      setSort(e.currentTarget.dataset.myValue);
    }
    setAnchorEl(null);
  };
  // End

  let clkindex = null;
  const commentSlide = (subPostId, index) => {
    getAllSubComments(subPostId);
    localStorage.setItem("subPostId", subPostId);
    clkindex = clkindex === index ? null : index;

    const priv = document.querySelector(".commetNesting.showComment");
    if (priv) {
      priv.classList.remove("showComment");
    }
    clkindex = index;
    const curr = document.getElementById("commentSlideID" + index);

    if (curr) {
      curr.classList.add("showComment");
    }

    // getAllSubComments(subPostId);
    // localStorage.setItem("subPostId", subPostId);
    // var element = document.getElementById("commentSlideID" + index);
    // element.classList.toggle("showComment");
  };

  const topCommentSlide = (postId) => {
    getAllComments(postId);
    var element = document.getElementById("topCommentSlideID");
    element.classList.toggle("showComment");
  };

  const handleClickOpen = (scrollType) => () => {
    setOpen(true);
    setScroll(scrollType);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleFormSubmit = () => {
    handleClose();
    handleClose2();
  };

  async function getAllPosts() {
    setPostData([]);
    setPostList([]);
    let dataval = localStorage.getItem("userId");
    let uId = JSON.parse(dataval);

    let inputData = {
      searchString: q,
      mostReplied: mostReplied,
      status: sort,
      pageNo: currentPage,
      count: itemsPerPage,
    };
    setShowLoader(true);
    await makePostRequest("post/postListing", inputData)
      .then((response) => {
        if (response.status === 201) {
          const data = response.data.data.data;
          if (data.length > 0) {
            // if (data[0].json_agg) {
            setPostList(data);
            setTotalItems(response.data.data.total_records);
            if (!loaddetails) {
              detailsPost(response.data.data.data[0]);
            }
            if (response.data.data.data[0].lmember_id !== null) {
              setselectedlikes(0);
              if (response.data.data.data[0].lmember_id.includes(uId)) {
                setselectedlikes(1);
              } else {
                setselectedlikes(0);
              }
            }
            setShowLoader(false);
            setloaddetails(false);
            // } else {
            //   setPostList([]);
            // }
          } else {
            setPostList([]);
            setShowLoader(false);
          }
          setShowLoader(false);
        } else {
          setShowLoader(false);
          swal("There was an error!", response.message, "warning");
        }
      })
      .catch((err) => {
        setShowLoader(false);
        swal("There was an error!", "more error details", "warning");
      });
  }

  async function getAllSubPosts(postId) {
    setShowLoader(true);
    await makeGetRequest("post/getallSubpost/" + postId)
      .then((response) => {
        if (response.status === 201) {
          const data = response.data.data;
          if (data[0].json_agg) {
            setSubPostList(data[0].json_agg);
            setShowLoader(false);
          }
        } else {
          swal("There was an error!", response.message, "warning");
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
  }

  async function getAllComments(postid) {
    setShowLoader(true);
    await makeGetRequest("post/viewcomment/" + postid)
      .then((response) => {
        if (response.status === 201) {
          // const data = response.data.data;
          if (response.data.data) {
            setCommentsList(response.data.data);
            setShowLoader(false);
            // getAllSubComments(response.data.data[0])
          }
        } else {
          swal("There was an error!", response.message, "warning");
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
  }

  async function getAllSubComments(subPostId) {
    setShowLoader(true);
    await makeGetRequest("post/viewsubcomment/" + subPostId)
      .then((response) => {
        if (response.status === 201) {
          if (response.data.data) {
            setSubCommentsList(response.data.data);
            setUpload(!Upload);
            setShowLoader(false);
          }
        } else {
          swal("There was an error!", response.message, "warning");
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
  }

  const detailsPost = async (postObj) => {
    seterrmsg(false);
    setloaddetails(true);
    setpostiddetail(postObj.postid);
    // setcommentcnt(0);
    // setreplycnt(0)
    setnoUpdate(true);
    // console.log(postObj.maincommentcount);
    let dataval = localStorage.getItem("userId");
    let uId = JSON.parse(dataval);
    if (postObj.lmember_id !== null) {
      setselectedlikes(0);
      if (postObj.lmember_id.includes(uId)) {
        setselectedlikes(1);
      } else {
        setselectedlikes(0);
      }
    }
    if (postObj.maincommentcount == null) {
      setcommentcnt(0);
    } else {
      setcommentcnt(postObj.maincommentcount);
    }

    if (postObj.postreplycount == null) {
      setreplycnt(0);
    } else {
      setreplycnt(postObj.postreplycount);
    }
    // setreplycnt(postObj.postreplycount);

    // if(postObj.maincommentcount != null && noUpdate) {
    //   setcommentcnt(postObj.maincommentcount);
    // }

    // if (postObj.postreplycount != null && noUpdate) {
    //   setreplycnt(postObj.postreplycount);//count
    // }

    setCommentsList([]);
    setSubCommentsList([]);
    setSubPostList([]);
    setSelectedItem(postObj);
    console.log("Selected Post Obj : ", postObj);
    setActiveIndex(postObj.postid);
    localStorage.setItem("selecetdPostObj", JSON.stringify(postObj));
    getAllSubPosts(postObj.postid);
    getAllComments(postObj.postid);
  };

  async function addSubPost(postid) {
    // e.preventDefault();

    // let subPost = document.getElementById("mainReply").value;
    if (postreplytext) {
      seterrmsg(false);
      var inputdata = "";

      inputdata = {
        postid: postid,
        sub_post_title: postreplytext,
        member_id: localStorage.getItem("userId"),
        is_new: true,
      };
      setShowLoader(true);
      await makePostRequest("post/addsubpost", inputdata)
        .then((response) => {
          if (response.data.status === "1") {
            // swal("Success", "Reply Sent", "success", {
            //   timer: 1000,
            //   buttons: false,
            // });
            setpostreplytext("");
            getAllSubPosts(postid);
            setnoUpdate(false);
            setreplycnt(replycnt + 1);
            getAllPosts();
            detailsPost(postiddetail);
            // setpostiddetail(postid)
            // setcommentcnt(commentcnt + 1)
            // setUpload(!Upload);
            document.getElementById("mainReply").value = "";
            setShowLoader(false);
          }
        })
        .catch((err) => {
          setShowLoader(false);
          swal(" " + err.response.data.message, "", "warning", {
            timer: 2000,
            buttons: false,
          });
        });
    } else {
      // swal("Empty Reply!", "Unable to send empty reply", "warning");
      seterrmsg(true);
    }
  }

  async function addComment(postid) {
    // e.preventDefault();

    let comment = document.getElementById("mainComment").value;
    if (maincomment) {
      setcommerrmsg(false);
      var inputdata = "";

      inputdata = {
        post_id: postid,
        post_comment: maincomment,
        member_id: localStorage.getItem("userId"),
      };
      setShowLoader(true);
      await makePostRequest("post/addcomment", inputdata)
        .then((response) => {
          if (response.data.status === "1") {
            setmaincomment("");
            document.getElementById("mainComment").value = "";
            getAllComments(postid);
            setnoUpdate(false);
            setcommentcnt(commentcnt + 1);
            getAllPosts();
            detailsPost(postiddetail);
            // setUpload(!Upload);
            setShowLoader(false);
          }
        })
        .catch((err) => {
          swal("There was an error!", "more error details", "warning");
        });
    } else {
      setcommerrmsg(true);
      // swal("Empty Reply!", "Unable to send empty reply", "warning");
    }
  }

  async function addSubComment(postid) {
    // e.preventDefault();
    let subComment = document.getElementById("subComment").value;
    if (subcomment) {
      setsubcommerrmsg(false);
      var inputdata = "";

      inputdata = {
        post_id: postid,
        sub_post_id: localStorage.getItem("subPostId"),
        sub_post_comment: subcomment,
        member_id: localStorage.getItem("userId"),
      };
      setShowLoader(true);
      await makePostRequest("post/addsubcomment", inputdata)
        .then((response) => {
          if (response.data.status === "1") {
            // console.log(response.data.data.sub_post_id)
            getAllSubPosts(postid);
            getAllSubComments(localStorage.getItem("subPostId"));
            setsubcomment("");
            // document.getElementById("subComment").value = "";
            // localStorage.removeItem("subPostId");
            setShowLoader(false);
            // getAllSubPosts(postiddetail)
          }
        })
        .catch((err) => {
          swal("There was an error!", "more error details", "warning");
        });
    } else {
      setsubcommerrmsg(true);
      // swal("Empty Reply!", "Unable to send empty reply", "warning");
    }
  }

  async function removeLike(data) {
    setShowLoader(true);
    let memberArr = data.lmember_id;
    let dataval = localStorage.getItem("userId");
    let loginId = JSON.parse(dataval);

    if (memberArr.includes(loginId)) {
      const index = memberArr.indexOf(loginId);
      if (memberArr.length === 1) {
        memberArr = null;
      } else {
        memberArr.splice(index, 1);
      }
    }

    let inputdata = {
      post_id: data.postid,
      member_id: memberArr,
      sender_id: data.sender_id,
    };

    await makePostRequest("post/updateMemberLike", inputdata)
      .then((response) => {
        console.log(response);
        if (response.status == "201") {
          setselectedlikes(0);
          getAllPosts();
          setShowLoader(false);
        }
      })
      .catch((err) => {
        setShowLoader(false);
        swal("There was an error!", "more error details", "warning");
      });
  }

  async function HandleLike(data) {
    console.log(data.lmember_id);
    setShowLoader(true);
    let memberArr = data.lmember_id;
    console.log("nnnn", memberArr);

    let dataval = localStorage.getItem("userId");
    let loginId = JSON.parse(dataval);

    await makeGetRequest("post/checkpostid/" + data.postid)
      .then((response) => {
        if (response.status === 201) {
          if (response.data.data.length > 0) {
            if (memberArr == null) {
              memberArr = [];
              memberArr.push(loginId);
            } else {
              memberArr.push(loginId);
            }
            // update members if post id present in like table
            inputdata = {
              post_id: data.postid,
              member_id: memberArr,
              sender_id: data.sender_id,
            };

            makePostRequest("post/updateMemberLike", inputdata)
              .then((response) => {
                console.log(response);
                if (response.status == "201") {
                  setShowLoader(false);
                  getAllPosts();
                }
              })
              .catch((err) => {
                setShowLoader(false);
                swal("There was an error!", "more error details", "warning");
              });
          } else {
            setShowLoader(true);
            if (memberArr == null) {
              memberArr = [];
              memberArr.push(loginId);
            } else {
              memberArr.push(loginId);
            }

            var inputdata = "";

            inputdata = {
              post_id: data.postid,
              member_id: memberArr,
              sender_id: data.sender_id,
            };
            makePostRequest("post/addlike", inputdata)
              .then((response) => {
                if (response.status === 201) {
                  setShowLoader(false);
                  getAllPosts();
                }
              })
              .catch((err) => {
                setShowLoader(false);
                swal("There was an error!", "more error details", "warning");
              });
          }
        }
      })
      .catch((err) => {
        setShowLoader(false);
        swal("There was an error!", "more error details", "warning");
      });
  }

  const handleEditForum = (scrollType, postidsave) => () => {
    // alert(postidsave)
    // localStorage.setItem("isEditNotice", true);
    localStorage.setItem("editpostId", postidsave);
    setOpen2(true);
    setScroll(scrollType);
  };

  const handleClose2 = () => {
    setOpen2(false);
    localStorage.removeItem("editpostId");
  };

  const chatExpandClick = () => {
    var element = document.getElementById("chatExpandId");
    element.classList.toggle("chatExpandedClass");
  };

  const [subcomment, setsubcomment] = React.useState("");
  const [postreplytext, setpostreplytext] = React.useState("");
  const [maincomment, setmaincomment] = React.useState("");

  const handleInputChange = (e, val) => {
    const inputValue = e.target.value.slice(0, 255);
    if (val === "postreply") {
      if (inputValue.trim() === "") {
        seterrmsg(true);
      } else if (inputValue.trim() !== inputValue) {
        seterrmsg(true);
      } else {
        seterrmsg(false);
      }
      setpostreplytext(inputValue);
    } else if (val === "replycomm") {
      if (inputValue.trim() === "") {
        setsubcommerrmsg(true);
      } else if (inputValue.trim() !== inputValue) {
        setsubcommerrmsg(true);
      } else {
        setsubcommerrmsg(false);
      }
      setsubcomment(inputValue);
    } else {
      if (inputValue.trim() === "") {
        setcommerrmsg(true);
      } else if (inputValue.trim() !== inputValue) {
        setcommerrmsg(true);
      } else {
        setcommerrmsg(false);
      }
      setmaincomment(inputValue);
    }

    // seterrmsg(false);
  };

  let clkindexdoc = null;
  const urls = [];
  const [bindurls, setbindurls] = React.useState([]);
  const viewDocs = (nId, index, fileuploaded) => {
    setbindurls([]);
    urls.length = 0;
    bindurls.length = 0;
    const btn = document.getElementById("noticeSlideID" + index);
    if (btn) {
      if (clkindexdoc !== null) {
        const prevDivindex = document.getElementById(
          "noticeSlideID" + clkindexdoc
        );
        if (prevDivindex) {
          prevDivindex.classList.remove("filesDiv");
        }
      }
      btn.classList.toggle("filesDiv");
      clkindexdoc = index;
    }
    fileuploaded.forEach((item) => {
      try {
        console.log(typeof item);
        const parsedItem = JSON.parse(item);

        if (parsedItem && parsedItem.path) {
          urls.push(parsedItem.path);
        } else {
          urls.push(item);
        }
      } catch (error) {
        urls.push(item);
        console.error("Error:", error);
      }
    });
    setbindurls(urls);
  };

  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    localStorage.removeItem("editpostId");
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
    setSelectedItem("");
    getAllPosts();
  }, [open, q, sort,currentPage]);
  // End

  React.useEffect(() => {
    if (q) {
      setCurrentPage(1);
    }
  }, [q]);
  
  // In your JSX where you're mapping the posts
  const postElements =
    postList.length > 0 ? (
      postList.map((option, index) => {
        const arr1 = option.lmember_id;
        let dataval = localStorage.getItem("userId");
        let uId = JSON.parse(dataval);
        let likeflagchk = 0;

        if (arr1?.includes(uId)) {
          likeflagchk = 1;
        } else {
          likeflagchk = 0;
        }

        return (
          <div
            key={option.postid}
            className={
              option.postid === activeIndex
                ? "parkSocityInner activeNotice"
                : "parkSocityInner"
            }
            onClick={() => detailsPost(option)}
            selectedItem={selectedItem}
          >
            <div className="parkSocityTop">
              <div className="parkSocityTopPro">
                {option.profile ? (
                  <Zoom>
                    <img src={option.profile} />
                  </Zoom>
                ) : (
                  <Zoom>
                    <img alt="Remy Sharp" src={avtarPic} />
                  </Zoom>
                )}
              </div>

              <h4>
                {option.fname} {option.lname}
              </h4>
              <div className="parkWi">
                <b>{option.contact_no}</b>{" "}
                <span>
                  {moment(option.created_at).format("DD/MM/YYYY h:mm:ss a")}
                </span>
              </div>
            </div>

            <div className="parContTxOuter">
              <h2 className="pstHead">{option.post_title}</h2>
              <p className="parContTx">
                {option.description.length > MAX_LENGTH ? (
                  <div
                    dangerouslySetInnerHTML={{
                      __html:
                        option.description.substring(0, MAX_LENGTH) + "...",
                    }}
                  ></div>
                ) : (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: option.description,
                    }}
                  ></div>
                )}
              </p>
            </div>

            <div className="parkSocialOut">
              {likeflagchk === 1 ? (
                <div onClick={() => removeLike(option)}>
                  <ThumbUpIcon className="likeStl" />
                  {option.lmember_id ? (
                    <span>
                      {option.lmember_id.length}
                      {option.likecount == 1 ? <> Like</> : <> Likes</>}
                    </span>
                  ) : (
                    <span>0 Like</span>
                  )}
                </div>
              ) : (
                <div onClick={() => HandleLike(option)}>
                  <ThumbUpIcon />
                  {option.lmember_id ? (
                    <span>
                      {option.lmember_id.length}
                      {option.likecount == 1 ? <> Like</> : <> Likes</>}
                    </span>
                  ) : (
                    <span>0 Like</span>
                  )}
                </div>
              )}

              <div>
                <CommentIcon />
                {option.postreplycount ? (
                  <span>{option.postreplycount} Reply</span>
                ) : (
                  <span>0 Reply</span>
                )}
              </div>
              <div>
                <CommentIcon />
                {option.maincommentcount ? (
                  <span>{option.maincommentcount} Comments</span>
                ) : (
                  <span>0 Comment</span>
                )}
              </div>

              <div onClick={handleEditForum("body", option.postid)}>
                <EditIcon />
                <span>Edit</span>
              </div>
              <div>
                {option?.fileuploaded?.length > 0 && (
                  <span
                    onClick={() =>
                      viewDocs(option.ticketid, index, option.fileuploaded)
                    }
                    className="downoadYourFile"
                  >
                    <FileDownloadIcon className="" />
                    <span>Download</span>
                  </span>
                )}
              </div>
            </div>

            <div className="expandfilesDiv" id={"noticeSlideID" + index}>
              {option?.fileuploaded?.length > 0 && (
                <>
                  {bindurls.map((opt, index) => (
                    <div id="documentDiv" className="doqumentDiv1">
                      <a href={opt} target="_blank">
                        <div className="doquView">
                          {opt.split(".").pop() == "txt" ? (
                            <img src={txtImage} />
                          ) : opt.split(".").pop() == "pdf" ? (
                            <img src={pdfImage} />
                          ) : opt.split(".").pop() == "docx" ||
                            opt.split(".").pop() == "doc" ? (
                            <img src={wordImage} />
                          ) : opt.split(".").pop() == "xls" ||
                            opt.split(".").pop() == "xlsx" ? (
                            <img src={excelImage} />
                          ) : (
                            <img src={opt} />
                          )}
                        </div>
                      </a>
                    </div>
                  ))}
                </>
              )}
            </div>
          </div>
        );
      })
    ) : (
      // <div className="Available">No Post Available....</div>
      <div className="recordNotFound reduceSize">
        <img src={reecordNotFound} />
      </div>
    );

  return (
    <>
      <Top />
      <Left />

      <div className="rightContent">
        <Grid container spacing={3} className="mainHeadingLine">
          <Grid item xs={12} md={12} className="oneLineBt">
            <h1 className="panelHeading">Discussion Forum</h1>
            <Button
              className="contentTopLefBt addCommiteeBt"
              onClick={handleClickOpen("body")}
            >
              Start Conversation
            </Button>
          </Grid>
          <Grid item xs={12} md={12}>
            <div
              className="noticePageMain discutionForumMain"
              id="chatExpandId"
            >
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <div className="visitorListNewInner">
                    <div className="visitorSearch">
                      <div className="visitorSearchDiv">
                        <SearchIcon className="visitorSearchIco" />
                        <input
                          type="text"
                          placeholder="Search"
                          onChange={(e) => setQ(e.target.value)}
                        />
                        {/* <MicIcon className="visitorMicIco" /> */}
                      </div>
                      <SortIcon
                        className="visitorFilterIco"
                        aria-controls={openMenu ? "basic-menu" : undefined}
                        aria-haspopup="true"
                        aria-expanded={openMenu ? "true" : undefined}
                        onClick={handleClick}
                      />
                      <Menu
                        id="basic-menu"
                        anchorEl={anchorEl}
                        open={openMenu}
                        onClose={handleCloseMenu}
                        MenuListProps={{
                          "aria-labelledby": "basic-button",
                        }}
                      >
                        <MenuItem
                          onClick={handleCloseMenu}
                          data-my-value={"newtoold"}
                        >
                          Newest to Oldest
                        </MenuItem>

                        <MenuItem
                          onClick={handleCloseMenu}
                          data-my-value={"oldtonew"}
                        >
                          Oldest to Newest
                        </MenuItem>

                        <MenuItem
                          onClick={handleCloseMenu}
                          data-my-value={"mostlikes"}
                        >
                          Most Liked
                        </MenuItem>

                        <MenuItem
                          onClick={handleCloseMenu}
                          data-my-value={"mostcomments"}
                        >
                          Most Commented
                        </MenuItem>

                        <MenuItem
                          onClick={handleCloseMenu}
                          data-my-value={"mostreply"}
                        >
                          Most Replied
                        </MenuItem>
                      </Menu>
                    </div>

                    <div className="noticeTabMain">
                      <Box sx={{ width: "100%" }}>
                        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                          <Tabs
                            value={value}
                            onChange={handleChange}
                            aria-label="basic tabs example"
                          >
                            <Tab label="All" {...a11yProps(0)} />
                            {/* <Tab label="Saved" {...a11yProps(1)} /> */}
                          </Tabs>
                        </Box>
                        <TabPanel
                          value={value}
                          index={0}
                          className="NoticeTabPanle"
                        >
                          <div className="noticeTbContDiv leftChatSecFor">
                            {postElements}
                            {/* {postList.length > 0 ?
                              <>
                                {
                                  postList.map((option, index) => (
                                    

{postElements}
                                  ))
                                }
                              </>
                              :
                              <div>
                                No Post Available....
                              </div>
                            } */}
                          </div>
                        </TabPanel>
                        {/* <TabPanel
                          value={value}
                          index={1}
                          className="NoticeTabPanle"
                        >
                          Item Two
                        </TabPanel> */}
                      </Box>
                      <Grid container spacing={3} >
                        <Grid item xs={12} md={12} >
                          <Pagination count={Math.ceil(totalItems / itemsPerPage)}
                            page={currentPage}
                            onChange={handlePageChange}
                            variant="outlined"
                            shape="rounded" />
                        </Grid>
                      </Grid>
                    </div>
                  </div>
                </Grid>

                {postList.length > 0 && (
                  <Grid item xs={12} md={6}>
                    <div className="forChatExpandMain">
                      <div className="discutiomMainBorder">
                        <div className="noticeRightCont discutiomRightMain discutiomMain">
                          <div className="parkSocityInner">
                            {/* <ArrowBackIcon
                            className="chatExpand"
                            onClick={chatExpandClick}
                          /> */}
                            <Tooltip title="Full View" placement="top" arrow>
                              <FullscreenIcon
                                className="chatExpand fullView"
                                onClick={chatExpandClick}
                              />
                            </Tooltip>
                            <Tooltip title="Small View" placement="top" arrow>
                              <FullscreenExitIcon
                                className="chatExpand shortView"
                                onClick={chatExpandClick}
                              />
                            </Tooltip>
                            <div className="parkSocityTop parkSocityTopForChat">
                              <div className="parkSocityTopPro">
                                {selectedItem.profile ? (
                                  <Zoom>
                                    <img src={selectedItem.profile} />
                                  </Zoom>
                                ) : (
                                  <Zoom>
                                    <img alt="Remy Sharp" src={avtarPic} />
                                  </Zoom>
                                )}
                              </div>
                              <h4>
                                {selectedItem.fname} {selectedItem.lname}
                              </h4>
                              <div className="parkWi">
                                <b>{selectedItem.contact_no}</b>{" "}
                                <span>
                                  {moment(selectedItem.created_at).format(
                                    "DD/MM/YYYY h:mm:ss a"
                                  )}
                                </span>
                              </div>
                            </div>
                            <h2 className="sbTitlSt">
                              {selectedItem.post_title}
                            </h2>
                            <p>
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: selectedItem.description,
                                }}
                              ></div>
                            </p>
                            <div className="parkSocialOut">
                              {selectedlikes === 1 ? (
                                <div onClick={() => removeLike(selectedItem)}>
                                  <ThumbUpIcon className="likeStl" />
                                  {selectedItem.lmember_id ? (
                                    <span>
                                      {selectedItem.lmember_id.length}
                                      {selectedItem.likecount == 1 ? (
                                        <> Like</>
                                      ) : (
                                        <> Likes</>
                                      )}
                                    </span>
                                  ) : (
                                    <span>0 Like</span>
                                  )}
                                </div>
                              ) : (
                                <div onClick={() => HandleLike(selectedItem)}>
                                  <ThumbUpIcon />
                                  {selectedItem.lmember_id ? (
                                    <span>
                                      {selectedItem.lmember_id.length}{" "}
                                      {selectedItem.likecount == 1 ? (
                                        <> Like</>
                                      ) : (
                                        <> Likes</>
                                      )}
                                    </span>
                                  ) : (
                                    <span>0 Like</span>
                                  )}
                                </div>
                              )}

                              <div>
                                <CommentIcon />
                                <span>{replycnt} Reply</span>
                                {/* {selectedItem.postreplycount ? (
                                  <span>
                                    {replycnt} Reply
                                  </span>
                                ) : (
                                  <span>0 Reply</span>
                                )} */}
                              </div>
                              <div
                                onClick={() =>
                                  topCommentSlide(selectedItem.postid)
                                }
                              >
                                <CommentIcon />
                                <span>{commentcnt} Comments</span>
                                {/* {selectedItem.maincommentcount ? (
                                  <span>
                                    {commentcnt} Comments
                                  </span>
                                ) : (
                                  <span>0 Comments</span>
                                )} */}
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Comment  Div   Start   */}

                        <div
                          className="topCommetNesting"
                          id="topCommentSlideID"
                        >
                          {commentsList ? (
                            <>
                              {commentsList.map((option) => (
                                <div className="parkSocityInner">
                                  <div className="parkSocityTop">
                                    <div className="parkSocityTopPro">
                                      {option.profile ? (
                                        <Zoom>
                                          <img src={option.profile} />
                                        </Zoom>
                                      ) : (
                                        <Zoom>
                                          <img
                                            alt="Remy Sharp"
                                            src={avtarPic}
                                          />
                                        </Zoom>
                                      )}
                                    </div>
                                    <h4>
                                      {option.fname} {option.lname}
                                    </h4>
                                    <div className="parkWi parkWiVericeAlign">
                                      <b>{option.contact_no}</b>{" "}
                                      <span>
                                        {moment(option.created_at).format(
                                          "DD/MM/YYYY h:mm:ss a"
                                        )}
                                      </span>
                                    </div>
                                  </div>
                                  <p className="parContTx">
                                    {option.post_comment}
                                  </p>
                                </div>
                              ))}
                            </>
                          ) : (
                            <div></div>
                          )}
                          <div className="commentInput">
                            <textarea
                              className="textAriaChat"
                              type="text"
                              id="mainComment"
                              placeholder="Add a comment to post..."
                              value={maincomment}
                              onChange={(e) => handleInputChange(e, "maincomm")}
                            ></textarea>
                            <SendIcon
                              onClick={() => addComment(selectedItem.postid)}
                            />
                          </div>
                          {commerrmsg ? (
                            <div
                              style={{ color: "red" }}
                              className="errorField"
                            >
                              {"Required and white spaces not allow"}
                            </div>
                          ) : null}
                        </div>
                        {/* Comment  Div   End   */}
                      </div>

                      {/* SubPost.... Reply Start */}

                      <div
                        className="disctionBottomContMain"
                        id="subpostlistdetails"
                      >
                        <div className="disctionComntScrol">
                          {subPostList.map((option1, index) => (
                            <>
                              <div className="parkSocityInner">
                                <div className="parkSocityTop">
                                  <div className="parkSocityTopPro">
                                    {option1.profile ? (
                                      <Zoom>
                                        <img src={option1.profile} />
                                      </Zoom>
                                    ) : (
                                      <Zoom>
                                        <img alt="Remy Sharp" src={avtarPic} />
                                      </Zoom>
                                    )}
                                  </div>
                                  <h4>
                                    {option1.fname} {option1.lname}
                                  </h4>
                                  <div className="parkWi">
                                    <b>{option1.contact_no}</b>{" "}
                                    <span>
                                      {moment(option1.created_at).format(
                                        "DD/MM/YYYY h:mm:ss a"
                                      )}
                                    </span>
                                  </div>
                                </div>
                                <div className="parContTxOuter">
                                  <p className="parContTx">
                                    {option1.sub_post_title}
                                  </p>
                                  <span>
                                      {moment(option1.created_at).format(
                                        "DD/MM/YYYY h:mm:ss a"
                                      )}
                                    </span>
                                </div>
                                <div className="parkSocialOut">
                                  {/* <div>
                                  <ThumbUpIcon />
                                  <span>42 Like</span>
                                </div> */}
                                  <div
                                    onClick={() =>
                                      commentSlide(option1.subpostid, index)
                                    }
                                  >
                                    <CommentIcon />
                                    {option1.subcommentcount ? (
                                      <span>
                                        {option1.subcommentcount} Comments
                                      </span>
                                    ) : (
                                      <span>0 Comments</span>
                                    )}
                                  </div>
                                </div>
                              </div>

                              {/* SubPost.... Reply End */}

                              {/* DIv For Nested Comments Start */}
                              <div
                                className="commetNesting"
                                id={"commentSlideID" + index}
                              >
                                {subCommentsList.map((key) => (
                                  <div className="parkSocityInner parkSocityInnerForChat">
                                    <div className="parkSocityTop">
                                      <div className="parkSocityTopPro">
                                        {key.profile ? (
                                          <Zoom>
                                            <img src={key.profile} />
                                          </Zoom>
                                        ) : (
                                          <Zoom>
                                            <img
                                              alt="Remy Sharp"
                                              src={avtarPic}
                                            />
                                          </Zoom>
                                        )}
                                      </div>
                                      <h4>
                                        {key.fname} {key.lname}
                                      </h4>
                                      <div className="parkWi parkWiVericeAlign">
                                        <b>{key.contact_no}</b>{" "}
                                        <span>
                                          {new Date(
                                            key.created_at
                                          ).toLocaleDateString("en-US")}{" "}
                                          &nbsp;
                                          {moment(key.created_at).format(
                                            "DD/MM/YYYY h:mm:ss a"
                                          )}
                                        </span>
                                      </div>
                                    </div>
                                    <div className="parContTxOuter">
                                      <p className="parContTx">
                                        {key.sub_post_comment}
                                      </p>
                                    </div>
                                  </div>
                                ))}
                                <div className="commentInput">
                                  <textarea
                                    className="textAriaChat"
                                    type="text"
                                    id="subComment"
                                    value={subcomment}
                                    onChange={(e) =>
                                      handleInputChange(e, "replycomm")
                                    }
                                    placeholder={`Add a comment to ${selectedItem.fname +
                                      " " +
                                      selectedItem.lname
                                      } reply...`}
                                  ></textarea>
                                  <SendIcon
                                    onClick={() =>
                                      addSubComment(selectedItem.postid)
                                    }
                                  />
                                </div>
                                {subcommerrmsg ? (
                                  <div
                                    style={{ color: "red" }}
                                    className="errorField"
                                  >
                                    {"Required and white spaces not allow"}
                                  </div>
                                ) : null}
                              </div>
                              {/* DIv For Nested Comments End */}
                            </>
                          ))}
                        </div>

                        <div className="typeComentOut">
                          <div className="typeComentOutIco chatTextAreaOut">
                            <SendIcon
                              onClick={() => addSubPost(selectedItem.postid)}
                            />
                            <textarea
                              type="text"
                              className="textAriaChat"
                              id="mainReply"
                              placeholder="Reply to post "
                              value={postreplytext}
                              onChange={(e) =>
                                handleInputChange(e, "postreply")
                              }
                            ></textarea>
                          </div>
                        </div>
                        {errmsg ? (
                          <div style={{ color: "red" }} className="errorField">
                            {"Required and white spaces not allow"}
                          </div>
                        ) : null}
                      </div>

                      {/* SubPost.... Reply End */}
                    </div>
                  </Grid>
                )}
              </Grid>
            </div>
          </Grid>
        </Grid>
      </div>

      <div className="modalMain">
        {/* <Button onClick={handleClickOpen("paper")}>scroll=paper</Button>
      <Button onClick={handleClickOpen("body")}>scroll=body</Button> */}
        <Dialog
          open={open}
          onClose={(event, reason) => {
            if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
              setOpen(false);
            }
          }}
          scroll={scroll}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogTitle id="scroll-dialog-title" className="modalHeading">
            <span>New Conversation</span>
            <CloseIcon className="modalCloseBt" onClick={handleClose} />
          </DialogTitle>
          <DialogContent dividers={scroll === "paper"}>
            <div className="modalInnerCont">
              <NewConversationModal onSubmitModal={handleFormSubmit} />
            </div>
          </DialogContent>
        </Dialog>
      </div>

      {/* for edit forum */}
      <div className="modalMain">
        <Dialog
          open={open2}
          // onClose={handleClose2}
          onClose={(event, reason) => {
            if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
              setOpen2(false);
            }
          }}
          scroll={scroll}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogTitle id="scroll-dialog-title" className="modalHeading">
            <span>Edit Conversation</span>
            <CloseIcon className="modalCloseBt" onClick={handleClose2} />
          </DialogTitle>
          <DialogContent dividers={scroll === "paper"}>
            <div className="modalInnerCont">
              <NewConversationModal onSubmitModal={handleFormSubmit} />
            </div>
          </DialogContent>
        </Dialog>
      </div>

      {showLoader ? (
        <div className="loaderOter" id="loaderId">
          <div className="wrapper">
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <span>Loading</span>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
}

export default DiscussionForumPage;
